
// {{{ Recordings.HistoryScreen

GW.define('Recordings.HistoryScreen', 'Main.Screen', {
	title: _('Nahrávky'),
	titleIcon: 'dialing',
	
	'after:initComponent'() {
		let me = this;

		this.el.classList.add('cdr-history-screen');
		this.bodyEl.gwReplaceChildren([{
			ref: 'toolbarEl',
			nodeName: 'form',
			'on:submit': ev => {
				ev.preventDefault();
				this.reload();
			},
			className: 'toolbar',
			children: this.renderToolbar(),
		}, {
			ref: 'table',
			xtype: 'FilterableSmartTable',
			extraClass: 'panel-container no-padding cdr-smart-table selectable',
			getColumns() {
				return me.getColumns().concat([me.getDetailsColumn()]);
			},
			'after:initComponent'() {
				this.el.addEventListener('click', ev => {
					let tr = ev.target.closest('tr');
					let checkbox = ev.target.closest('.row-checkbox');
					let button = ev.target.closest('button.call-rec-detail');
					if (tr && tr.$data && button) {
						me.showRecordings(tr.$data);
					} else if (tr && !checkbox && !button) {
						checkbox = tr.querySelector('.row-checkbox');
						if (checkbox) {
							checkbox.checked = !checkbox.checked;
							checkbox.dispatchEvent(new Event('input'));
						}
					}
				}, true);
			},
			renderRow(tr, row) {
				tr.dataset.direction = row.direction || '';
				tr.dataset.result = row.result || '';
			},
		}], this);

		setTimeout(() => {
			// help firefox
			let el = this.el.querySelector('[autofocus]');
			el && el.focus();
		}, 0);

		this.on('change', c => this.updateParams(), null, true);

		this.updateDownloadButton();
	},

	getLiveToolbarSearchFields() {
		return this.getChildren(c => {
			return c.fromParams && c.toParams && c.toQuery && c.el.closest('.toolbar');
		});
	},
	
	updateDownloadButton() {
		const selectedCount = this.getSelectedIds().length;
		if (this.table.checkBoxCheckAll.checked || selectedCount == 0) {
			this.downloadBtn.gwReplaceChildren([
				Utils.useIcon('download'),
				_('Stáhnout vše')
			]);
		} else {
			this.downloadBtn.gwReplaceChildren([
				Utils.useIcon('download'),
				_('Stáhnout vybrané ({count})').replace('{count}', selectedCount)
			]);
		}
		this.downloadBtn.disabled = !(selectedCount || this.table.el.querySelector('.row-checkbox'));
	},
	
	buildCheckColumn() {
		return {
			id: 'check',
			name: {
				nodeName: 'input',
				type: 'checkbox',
				ref: 'checkBoxCheckAll',
				'on:input': (e) => {
					this.table.el.querySelectorAll('.row-checkbox').forEach(el => {
						el.checked = e.target.checked;
						el.parentNode.parentNode.classList.toggle('selected', e.target.checked);
					});
					this.updateDownloadButton();
				}
			},
			formatCell: (td, v, row) => {
				td.gwCreateChild({
					nodeName: 'input',
					className: 'row-checkbox',
					type: 'checkbox',
					'attr:data-id': row.id,
					'on:input': e => {
						td.parentNode.classList.toggle('selected', e.target.checked);
						const allCount = this.table.el.querySelectorAll('.row-checkbox').length;
						const selectedCount = this.getSelectedIds().length;
						this.table.checkBoxCheckAll.checked = allCount == selectedCount;
						this.updateDownloadButton();
					}
				});
			},
		}
	},
	
	getSelectedIds() {
		return [...this.table.el.querySelectorAll('.row-checkbox:checked')].map(el => el.dataset.id);
	},

	getColumns() {
		return [this.buildCheckColumn(), {
			id: 'direction',
			name: _('Směr'),
			formatCell(td, v, row) {
				td.gwCreateChild(Office.renderDirectionIcon(row, true));
				td.gwCreateChild(Formats.call_direction(v));
			},
			filter: {
				type: 'options',
			},
			sortable: {
				type: 'string',
				value: v => Formats.call_direction(v),
			}
		}, {
			id: 'start',
			format: 'datetime',
			name: _('Začátek hovoru'),
			sortable: {
				type: 'numeric',
			},
		}, {
			id: 'duration',
			format: 'duration',
			name: _('Délka hovoru'),
			filter: {
				type: 'duration',
			},
			sortable: {
				type: 'numeric'
			},
		}, {
			id: 'queue',
			name: _('Vstupní fronta'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'caller',
			name: _('Volající'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'caller_name',
			name: _('Jméno'),
			fullName: _('Jméno volajícího'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'caller_company',
			name: _('Firma'),
			fullName: _('Firma volajícího'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'callee',
			name: _('Volaný'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'callee_name',
			name: _('Jméno'),
			fullName: _('Jméno volaného'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}, {
			id: 'callee_company',
			name: _('Firma'),
			fullName: _('Firma volaného'),
			filter: {
				type: 'options',
				showSearch: true,
			},
			sortable: {
				type: 'string',
			},
		}];
	},

	getDetailsColumn() {
		return {
			id: 'details',
			name: '',
			formatCell(td, v, row) {
				if (row.has_recordings) {
					td.gwCreateChild({
						nodeName: 'button',
						className: 'small secondary icon-left call-rec-detail',
						children: [Utils.useIcon('dialing'), _('Detail')],
						title: row.recordings_readable ? _('Zobrazit nahrávky') : _('K nahrávkám nemáte přístup'),
						disabled: !row.recordings_readable,
					});
				} 
			}
		};
	},

	/*
	 * PLUGIN: extension point for search
	 */
	renderToolbarSearchFields() {
		return [{
			xtype: 'Widgets.DateRangeInput',

			fromParams(params) {
				let range = params.get('range') || 'today';

				this.setRangeOption(range);

				if (range == 'custom') {
					this.setTimeRange(
						params.get('since'),
						params.get('until')
					);
				}
			},
			toParams(params) {
				let range = this.getRange();
				if (range == 'custom') {
					let [since, until] = this.getTimeRange();
					params.set('since', since || '');
					params.set('until', until || '');
					params.delete('range');
				} else {
					params.delete('since');
					params.delete('until');
					params.set('range', range);
				}

				this.updateTimeFields();
			},
			toQuery(query) {
				let [since, until] = this.getTimeRange();

				query.since = since;
				query.until = until;
			},
		}, {
			xtype: 'TextField',
			extraClass: 'small',
			label: _('Telefon'),
			optional: true,

			fromParams(params) {
				this.setValue(params.get('number') || '');
			},
			toParams(params) {
				let number = this.getValue() || '';
				if (number) {
					params.set('number', number);
				} else {
					params.delete('number');
				}
			},
			toQuery(query) {
				query.extension = this.getValue() || undefined;
			},
		}, {
			xtype: 'TextField',
			extraClass: 'small',
			label: _('Vstupní fronta'),
			optional: true,

			fromParams(params) {
				this.setValue(params.get('queue') || '');
			},
			toParams(params) {
				let queue = this.getValue() || '';
				if (queue) {
					params.set('queue', queue);
				} else {
					params.delete('queue');
				}
			},
			toQuery(query) {
				query.queue = this.getValue() || undefined;
			},
		}];
	},

	renderToolbar() {
		return [...this.renderToolbarSearchFields(), {
			nodeName: 'button',
			type: 'submit',
			className: 'primary small',
			textContent: _('Zobrazit'),
		}, {
			nodeName: 'button',
			type: 'button',
			ref: 'downloadBtn',
			className: 'secondary small icon-left',
			"on:click": async () => {
				let query = Object.fromEntries(
					Object.entries(this.buildQuery()).filter(([k, v]) => v != null)
				);
				let group = Application.getActiveUserGroup();
				if (group) {
					query.active_user_group = group.id;
				}

				try {
					let res = await fetch(API_BASE + 'calls/export/recordings?' + new URLSearchParams(query).toString(), {
						method: 'POST',
						mode: 'same-origin',
						headers: {
							'Content-Type': 'application/json;charset=utf-8',
							'X-Anti-CSRF': '1',
						},
						body: JSON.stringify({call_ids: this.getSelectedIds()}),
						cache: 'default',
					});
					
					const filename = 'recordings.zip';

					if (res.ok) {
						let blob = new File([await res.blob()], filename);
						let file = URL.createObjectURL(blob);

						const a = document.createElement("a");
						a.href = file;
						a.download = filename;
						a.click();
						window.URL.revokeObjectURL(file);
					} else {
						let errData = {};
						try {
							errData = await res.json();
						} catch (ex) {}

						let err = new RESTError((errData || {}).error || `ZIP export failed with status: ${res.status}`);
						err.status = res.status;
						throw err;
					}
				} catch (ex) {
					if (ex instanceof DOMException) {
						throw new AbortError();
					}

					throw ex;
				}
			},
		}];
	},

	async showRecordings(call) {
		let recordings = await REST.GET('calls/' + encodeURIComponent(call.id) + '/recordings');

		let dlg = new CDR.CallRecordingsDialog({
			recordingsBaseUrl: API_BASE + 'calls/' + encodeURIComponent(call.id) + '/recordings/',
		});

		dlg.setRecordings(recordings);
	},

	/*
	 * Update URL query parameters from the input fields.
	 */
	updateParams() {
		Application.route({
			resolve: false,
			paramsFn: params => {
				for (let f of this.getLiveToolbarSearchFields()) {
					f.toParams(params);
				}

				return params;
			},
		});
	},

	maxCalls: 3000,

	buildQuery() {
		const query = {};
		for (let f of this.getLiveToolbarSearchFields()) {
			f.toQuery(query);
		}
		return query;
	},

	async reload() {
		let list = await REST.GET('calls', {
			...this.buildQuery(),
			limit: this.maxCalls,
			has_recordings: true,
		});
		if (list.length >= this.maxCalls) {
			Application.notify({
				text: _('Pokoušíte se zobrazit více jak {max} hovorů, pro jejich získání použijte export do XLSX, nebo použijte jiný filtr.')
					.replace('{max}', this.maxCalls),
			});
		}

		for (let call of list) {
			call.caller_name = call.caller && call.caller.name;
			call.callee_name = call.callee && call.callee.name;

			call.caller_company = call.caller && call.caller.company;
			call.callee_company = call.callee && call.callee.company;

			call.caller = call.caller && call.caller.number;
			call.callee = call.callee && call.callee.number;
		}

		this.table.setData(list);
		this.updateDownloadButton();
	},

	async applyParams(params) {
		for (let f of this.getLiveToolbarSearchFields()) {
			f.fromParams(params);
		}
	},
});


// }}}
// {{{ Routes

Application.addRoutes([{
	group: 'auth',
	module: 'recordings',
	path: APP_BASE + 'recordings',
	async handler({params}) {
		let c = Application.show({
			id: 'recordings.history',
			xtype: 'Recordings.HistoryScreen',
		});

		c.applyParams(params);
	}    
}]);

// }}}

Application.registerModule({
	id: 'recordings',
	title: _('Nahrávky'),
	tagline: _('Poslech a stažení nahrávek hovorů'),
	icon: 'dialing',
	href: APP_BASE + 'recordings',
});
